/**
 * Deep-copy a *JSON-serializable* object. **Warning:** if you pass in a reactive object, this
 * returns a *non-reactive* object
 */
export function deepCopyObj<T>(d: T): T {
  return JSON.parse(JSON.stringify(d));
}
